import { Box, Button, Icons, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { goToSubmissions } from '@app/actions/navigation';
import { VIEW_SUBMISSIONS } from '@app/constants/texts';
import { selectCurrentAssignmentId } from '@core/assignments/selectors';
import { getCurrentSpaceId } from '@core/selectors/space';
import { AulaState } from '@core/types/state';
import { createStyles } from './AssignmentDetails.styles';

const AssignmentDetails = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const dispatch = useDispatch();
  const spaceId = useSelector((state: AulaState) => getCurrentSpaceId(state));
  const assignmentId = useSelector(selectCurrentAssignmentId);
  const canViewSubmissions = Boolean(spaceId && assignmentId);

  // Reuses the legacy submissions route:
  // /dashboard/:spaceId/journey/assignments/:assignmentId/submissions
  const handleViewSubmissions = () => {
    if (!canViewSubmissions) {
      return;
    }

    dispatch(goToSubmissions({ spaceId, assignmentId }));
  };

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.actions}>
        <Button
          type="button"
          kind="primary"
          sx={styles.viewSubmissionsButton}
          disabled={!canViewSubmissions}
          onClick={handleViewSubmissions}
        >
          <Icons.AssessmentOutlined fontSize="small" />
          {VIEW_SUBMISSIONS}
        </Button>
      </Box>
    </Box>
  );
};

export default AssignmentDetails;
